import Marionette from "backbone.marionette";

import PermissionsTpl from "views/permissions/permissions.ejs";
import PermissionsList from "views/permissions/permissionsList.js";

import CSS from "views/permissions/permissions.css";

import S from "session/session.js";
import T from "session/token.js";

export default Marionette.LayoutView.extend({
    template: PermissionsTpl,
    render: function() {
        this.collection.fetch({
            beforeSend: T.useToken,
            data: {
                user_id: this.model.id,
                role: this.model.attributes.role,
                company: S.companyId,
                instanceId: S.instanceId
            },
            success: this.applyView.bind(this)
        });
    },
    events: {
        "click #include": "include",
        "click #exclude": "exclude",
        "change #selectEnv": "showPermissions",
        "click #send": "submit"
    },
    applyView: function() {

        // Merge local and generic translations for the template scope
        Object.assign(this.collection.lang, S.userInfo.attributes.lang);
        

        this.$el.html(this.template({
            lang: this.collection.lang,
            role: this.model.attributes.role,
            first_name: this.model.attributes.first_name,
            last_name: this.model.attributes.last_name,
            role_user: S.userInfo.attributes.role
        }));

        ////USUARIO GESTOR - Y USUARIO NORMAL 
        if (this.model.attributes.role === "3" || this.model.attributes.role === "2") {
            $("#env_no_view").empty();
            $("#env_view").empty();

            _.each(this.collection.models[0].attributes.instances, function(instance) {
                if (!instance.user_id) {
                    $("#env_no_view").append('<option value="' + instance.id + '">' + instance.name + '</option>');
                } else {
                    $("#env_view").append('<option value="' + instance.id + '">' + instance.name + '</option>');
                    //Fill combo with visible envs
                    $("#selectEnv").append('<option value="' + instance.id + '">' + instance.name + '</option>');
                }
            });
        } else {
            $("#company_no_view").empty();
            $("#company_view").empty();
            _.each(this.collection.models, function(model) {
                if (!model.attributes.userId) {
                    $("#company_no_view").append('<option value="' + model.id + '">' + model.attributes.name + '</option>');
                } else {
                    $("#company_view").append('<option value="' + model.id + '">' + model.attributes.name + '</option>');
                }
            });
        }
    },
    include: function(ev) {
        ev.preventDefault();
        $("#env_no_view :selected, #company_no_view :selected").each(function() {
            $("#env_view, #company_view").append('<option value="' + $(this).attr("value") + '">' + $(this).text() + '</option>');
            $(this).remove();
        });

        this.syncSelectEnv();
    },
    exclude: function(ev) {
        ev.preventDefault();
        $("#env_view :selected, #company_view :selected").each(function() {
            $("#env_no_view, #company_no_view").append('<option value="' + $(this).attr("value") + '">' + $(this).text() + '</option>');
            $(this).remove();
        });

        this.syncSelectEnv();
    },
    //Fill combo with visible envs
    syncSelectEnv: function() {
        $("#selectEnv").empty().append('<option>' + this.collection.lang.SELECT_ENV + '</option');
        $("#env_view option").each(function() {
            $("#selectEnv").append('<option value="' + $(this).attr("value") + '">' + $(this).text() + '</option>');
        });
    },
    showPermissions: function(ev) {


        $("#permissionSet").html('');

        if (isNaN($(ev.target).val())) {

            $("#permissionSet").empty();
            return;
        }

        this.collection.fetch({
            beforeSend: T.useToken,
            data: {
                user_id: this.model.id,
                instance_id: $(ev.target).val(),
                company: S.companyId
            },
            success: function() {
                // Merge local and generic translations for the template scope
                Object.assign(this.collection.lang, S.userInfo.attributes.lang);

                this.permissionSet.show(new PermissionsList({
                    collection: this.collection,
                    role_us: this.model.attributes.role
                }));
            }.bind(this)
        });
    },
    submit: function(ev) {
        var formData = {};
        /////USUARIO NORMAL Y USUARIO GESTOR ..
        if (this.model.attributes.role === "3" || this.model.attributes.role === "2") {
            formData.instances = [];
            $.each($("#env_view option"), function() {
                formData.instances.push(parseInt($(this).attr("value")));
            })

            formData.permissions = [];
            $.each($(".subepigraph"), function() {
                var value = 0;
                var valuebaja = 0;

                value = $(this).find(".view").prop("checked") === true ? 1 : value;
                value = $(this).find(".edit").prop("checked") === true ? 2 : value;
                value = $(this).find(".delete").prop("checked") === true ? 3 : value;
                ////poder dar de baja fichas no borrar. 
                valuebaja = $(this).find(".bajafichas").prop("checked") === true ? 1 : 0;

                formData.permissions.push({
                    id: $(this).attr("id"),
                    item: $(this).attr("data-item"),
                    value: value,
                    isbajaFicha: valuebaja,
                });
            });

            formData.user_id = this.model.id;
            formData.instance_id = $("#selectEnv").val();
            formData.role = this.model.attributes.role;
        } else {
            formData.companies = [];
            $.each($("#company_view option"), function() {
                formData.companies.push(parseInt($(this).attr("value")));
            });

            formData.user_id = this.model.id;
            formData.role = "1";
        }

        //Force POST operation
        delete this.collection.models[0].id;

        this.collection.models[0].save(formData, {
            beforeSend: T.useToken,
            success: function() {
                S.mApp.trigger("notify:success", {
                    message: S.userInfo.attributes.lang.INSERT_OK
                });
            },
            error: function() {
                S.mApp.trigger("notify:error", {
                    message: S.userInfo.attributes.lang.INSERT_ERROR
                });
            }
        });

        return false;
    },
    regions: {
        "permissionSet": "#permissionSet"
    }
});


//////////////////
// WEBPACK FOOTER
// ./app/views/permissions/permissionsView.js
// module id = 203
// module chunks = 0